import { PlaneIcon, HotelIcon, ActivityIcon } from "./icons";
import BookingDropdown from "./BookingDropdown";

const RestaurantIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

const CabIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h8m-8 4h8m-4-8v2m-6 6h2m12 0h2M5 19h14a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2zm3-2a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z" />
  </svg>
);

const FoodIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

const SmartBookingLinks = ({ day, bookingLinks, tripSummary, localServices }) => {
  const content = `${day.title || ''} ${day.description || ''} ${(day.highlights || []).join(' ')}`.toLowerCase();

  const hasTransport = content.includes('airport') || content.includes('flight') ||
                       content.includes('arrival') || content.includes('departure') ||
                       content.includes('transfer');
  const hasHotel = content.includes('hotel') || content.includes('check-in') ||
                   content.includes('check in') || content.includes('accommodation') ||
                   content.includes('resort') || content.includes('stay');
  const hasSightseeing = content.includes('visit') || content.includes('temple') ||
                         content.includes('shrine') || content.includes('museum') ||
                         content.includes('garden') || content.includes('tour') ||
                         content.includes('explore') || content.includes('monument') ||
                         content.includes('palace') || content.includes('fort') ||
                         content.includes('beach') || content.includes('park');
  const hasDining = content.includes('dinner') || content.includes('lunch') ||
                    content.includes('breakfast') || content.includes('restaurant') ||
                    content.includes('food') || content.includes('cuisine') ||
                    content.includes('cafe') || content.includes('meal');
  const hasLocalTransport = content.includes('taxi') || content.includes('cab') ||
                            content.includes('uber') || content.includes('grab') ||
                            content.includes('ride') || content.includes('transport') ||
                            content.includes('drive') || content.includes('pickup');

  if (!hasTransport && !hasHotel && !hasSightseeing && !hasDining && !hasLocalTransport) {
    return null;
  }

  const destination = tripSummary?.destination || '';
  const country = tripSummary?.country || '';
  const startingLocation = tripSummary?.startingLocation || '';

  const optionsCount = [hasTransport, hasHotel, hasSightseeing, hasDining, hasLocalTransport].filter(Boolean).length;

  const getGridCols = () => {
    if (optionsCount === 1) return 'grid-cols-1';
    if (optionsCount === 2) return 'grid-cols-2';
    if (optionsCount === 3) return 'grid-cols-3';
    return 'grid-cols-2 sm:grid-cols-4';
  };

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3">
        Book for this day
      </p>
      <div className={`grid ${getGridCols()} gap-2`}>
        {hasTransport && (
          <BookingDropdown
            category="flights"
            destination={destination}
            country={country}
            fromLocation={startingLocation}
            icon={PlaneIcon}
            label="Flights"
            bookingLinks={bookingLinks}
            localServices={localServices}
          />
        )}

        {hasHotel && (
          <BookingDropdown
            category="hotels"
            destination={destination}
            country={country}
            icon={HotelIcon}
            label="Hotels"
            bookingLinks={bookingLinks}
            localServices={localServices}
          />
        )}

        {hasSightseeing && (
          <BookingDropdown
            category="activities"
            destination={destination}
            country={country}
            icon={ActivityIcon}
            label="Activities"
            bookingLinks={bookingLinks}
            localServices={localServices}
          />
        )}

        {hasLocalTransport && (
          <BookingDropdown
            category="rideshare"
            destination={destination}
            country={country}
            icon={CabIcon}
            label="Cabs"
            bookingLinks={bookingLinks}
            localServices={localServices}
          />
        )}

        {hasDining && (
          <BookingDropdown
            category="foodDelivery"
            destination={destination}
            country={country}
            icon={FoodIcon}
            label="Food"
            bookingLinks={bookingLinks}
            localServices={localServices}
          />
        )}
      </div>
    </div>
  );
};

export default SmartBookingLinks;
